const baseUrlCombustion = "https://api.tomtom.com/routing/1/calculateRoute";
const baseUrlEV =
    "https://api.tomtom.com/routing/1/calculateLongDistanceEVRoute";
const baseUrlRange =
    "https://api.tomtom.com/routing/1/calculateReachableRange";
const baseUrlCustom = "http://localhost:1234/routing/1/calculateRoute";
const traffic = false;
const DEFAULTS = {
    CURRENT_CHARGE_PCT: 0.8,
    MIN_CHARGE_AT_CHARGING_STOP: 0.1,
    MIN_CHARGE_AT_DESTINATION: 0.2
};


/**
 * 
 * @param {string} coordinates of format "startLat,startLong:destLat,destLong"
 * @param {string} key a valid API-Key for the TomTom API
 * @param {function} callback a function that gets called with the response
 */
export function calculateCombustionRoute(coordinates, key, callback) {
    const url = `${baseUrlCombustion}/${coordinates}/json?\
maxAlternatives=0&language=de-DE\
&computeBestOrder=false\
&routeRepresentation=polyline\
&computeTravelTimeFor=all\
&sectionType=travelMode\
&departAt=now\
&routeType=fastest\
&traffic=${traffic}\
&avoid=unpavedRoads\
&travelMode=car\
&vehicleCommercial=false\
&vehicleEngineType=combustion\
&key=${key}`;
    httpGetAsync(url, callback, { name: "Combustion" });
}

/**
 * 
 * @param {string} coordinates of format "startLat,startLong:destLat,destLong"
 * @param {string} key a valid API-Key for the TomTom API
 * @param {[vehicle1, vehicle2, ...]} vehicleData a list of all the vehicles to calculate routes for
 * @param {function} callback a function that gets called with the response
 */
export function calculateEVRoutes(coordinates, key, vehicleData, callback, context = null) {
    vehicleData.forEach((vehicle) => {
        if (vehicle.active == false) // only skip vehicles that have active attribute and it's value is false
            return;
        calculateEVRoute(coordinates, key, vehicle, callback, context);
        calculateOwnEVRoute(coordinates, JSON.parse(JSON.stringify(vehicle)), callback, context);
    });
}

export function getOwnUrl(coordinates, vehicle, defaults = DEFAULTS) {
    var url = `${baseUrlCustom}/${coordinates}/json?`;
    url += `maxChargeInkWh=${vehicle.maxCharge}`;
    url += `&constantSpeedConsumptionInkWhPerHundredkm=${vehicle.constantSpeedConsumption}`;
    if (vehicle.currentChargeInkWh)
        url += `&currentChargeInkWh=${vehicle.currentChargeInkWh.toFixed(2)}`;
    else
        url += `&currentChargeInkWh=${(vehicle.maxCharge * DEFAULTS.CURRENT_CHARGE_PCT).toFixed(2)}`;
    if (vehicle.minChargeAtDestinationInkWh)
        url += `&minChargeAtDestinationInkWh=${vehicle.minChargeAtDestinationInkWh.toFixed(2)}`;
    else
        url += `&minChargeAtDestinationInkWh=${(vehicle.maxCharge * defaults.MIN_CHARGE_AT_DESTINATION).toFixed(2)}`;
    if (vehicle.minChargeAtChargingStopsInkWh)
        url += `&minChargeAtChargingStopsInkWh=${vehicle.minChargeAtChargingStopsInkWh.toFixed(2)}`;
    else
        url += `&minChargeAtChargingStopsInkWh=${(vehicle.maxCharge * defaults.MIN_CHARGE_AT_CHARGING_STOP).toFixed(2)}`;
    return url;
}

export function calculateOwnEVRoute(coordinates, vehicle, callback, context = null) {
    const url = getOwnUrl(coordinates, vehicle);
    vehicle.name += " (ours)";
    vehicle.color = "#ff0000";
    httpPostAsync(url, JSON.stringify(vehicle.body), callback, vehicle, context);
}

/**
 * 
 * @param {string} coordinates of format "startLat,startLong:destLat,destLong"
 * @param {string} key a valid API-Key for the TomTom API
 * @param {Object} vehicle a specific vehicles to calculate the route for
 * @param {function} callback a function that gets called with the response
 */
export function calculateEVRoute(coordinates, key, vehicle, callback, context = null, defaults = DEFAULTS) {
    const body = JSON.stringify(vehicle.body);
    var url = `${baseUrlEV}/${coordinates}/json?vehicleEngineType=electric&avoid=unpavedRoads&traffic=${traffic}`;
    url += `&key=${key}`;
    url += `&constantSpeedConsumptionInkWhPerHundredkm=${vehicle.constantSpeedConsumption}`;
    url += `&maxChargeInkWh=${vehicle.maxCharge}`;
    if (vehicle.currentChargeInkWh)
        url += `&currentChargeInkWh=${vehicle.currentChargeInkWh.toFixed(2)}`;
    else
        url += `&currentChargeInkWh=${(vehicle.maxCharge * defaults.CURRENT_CHARGE_PCT).toFixed(2)}`;
    if (vehicle.minChargeAtDestinationInkWh)
        url += `&minChargeAtDestinationInkWh=${vehicle.minChargeAtDestinationInkWh.toFixed(2)}`;
    else
        url += `&minChargeAtDestinationInkWh=${(vehicle.maxCharge * defaults.MIN_CHARGE_AT_DESTINATION).toFixed(2)}`;
    if (vehicle.minChargeAtChargingStopsInkWh)
        url += `&minChargeAtChargingStopsInkWh=${vehicle.minChargeAtChargingStopsInkWh.toFixed(2)}`;
    else
        url += `&minChargeAtChargingStopsInkWh=${(vehicle.maxCharge * defaults.MIN_CHARGE_AT_CHARGING_STOP).toFixed(2)}`;
    if (vehicle.weight)
        url += `&vehicleWeight=${vehicle.weight}`;
    if (vehicle.uphillEfficiency)
        url += `&uphillEfficiency=${vehicle.uphillEfficiency}`;
    if (vehicle.downhillEfficiency)
        url += `&downhillEfficiency=${vehicle.downhillEfficiency}`;
    if (vehicle.auxiliaryPower)
        url += `&auxiliaryPowerInkW=${vehicle.auxiliaryPower}`;
    
    httpPostAsync(url, body, callback, vehicle, context);
}

/**
 * 
 * @param {string} coordinates of format "startLat,startLong:destLat,destLong"
 * @param {string} key a valid API-Key for the TomTom API
 * @param {Object} vehicle a specific vehicles to calculate the route for
 * @param {number} energyBudgetInkWh the range in kWh to display as a polygon
 * @param {function} callback a function that gets called with the response
 */
export function calculateReachableRange(coordinates, key, vehicle, energyBudgetInkWh, callback) {
    let url = `${baseUrlRange}/${coordinates}/json?vehicleEngineType=electric&avoid=unpavedRoads&key=${key}\
&energyBudgetInkWh=${energyBudgetInkWh.toFixed(2)}\
&traffic=${traffic}\
&constantSpeedConsumptionInkWhPerHundredkm=${vehicle.constantSpeedConsumption}\
&currentChargeInkWh=${energyBudgetInkWh.toFixed(2)}\
&maxChargeInkWh=${vehicle.maxCharge}`;
    if (vehicle.weight)
        url += `&vehicleWeight=${vehicle.weight}`;
    if (vehicle.uphillEfficiency)
        url += `&uphillEfficiency=${vehicle.uphillEfficiency}`;
    if (vehicle.downhillEfficiency)
        url += `&downhillEfficiency=${vehicle.downhillEfficiency}`;
    if (vehicle.auxiliaryPower)
        url += `&auxiliaryPowerInkW=${vehicle.auxiliaryPower}`;
    httpGetAsync(url, callback, vehicle);
}

function httpGetAsync(theUrl, callback, callbackInfo = null, context = null) {
    var xmlHttp = new XMLHttpRequest();
    xmlHttp.onreadystatechange = function () {
        if (xmlHttp.readyState == 4 && xmlHttp.status == 200) {
            if (callbackInfo) callback(xmlHttp.responseText, callbackInfo);
            else callback(xmlHttp.responseText);
        } else if (xmlHttp.readyState == 4) {
            if (context)
                context.$bvToast.toast(xmlHttp.responseText, {
                    title: `Error ${xmlHttp.status} receiving data for ${callbackInfo.name} (GET)`,
                    noAutoHide: true,
                    variant: "danger"
                });
            console.warn(xmlHttp.status, xmlHttp.responseText);
        }
    };
    xmlHttp.open("GET", theUrl, true); // true for asynchronous
    xmlHttp.send(null);
}

function httpPostAsync(theUrl, body, callback, callbackInfo = null, context = null) {
    var xmlHttp = new XMLHttpRequest();
    xmlHttp.onreadystatechange = function () {
        if (xmlHttp.readyState == 4 && xmlHttp.status == 200) {
            if (callbackInfo) callback(xmlHttp.responseText, callbackInfo);
            else callback(xmlHttp.responseText);
        } else if (xmlHttp.readyState == 4) {
            if (context)
                context.$bvToast.toast(xmlHttp.responseText, {
                    title: `Error ${xmlHttp.status} receiving data for ${callbackInfo.name} (POST)`,
                    noAutoHide: true,
                    variant: "danger"
                });
            console.warn(xmlHttp.status, xmlHttp.responseText);
        }
    };
    xmlHttp.open("POST", theUrl, true); // true for asynchronous
    xmlHttp.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
    xmlHttp.send(body);
}